<kendo-card class="intake-card-help" width="100%">
    <div class="help-section">
        <h1>Can We Help You?</h1>
        <p class="mr-50">If you need more support or need to contact us about any part of your assignment submission, please email us at <a href="mailto:services@nefco.net" class="kendo-anchor-tag">services@nefco.net</a>.</p>
    </div>
</kendo-card>